/**
 * These are the data that are displayed on the front page of a form.
 */
import {
    CustomerIdentificationInputField,
    initialCustomerIdentificationInputFieldState,
} from './customer-identification-input-field';

export type CustomerIdentification = Readonly<{
    customer1: CustomerIdentificationInputField;
    customer2: CustomerIdentificationInputField;
    address1: CustomerIdentificationInputField;
    address2: CustomerIdentificationInputField;
    communication1?: CustomerIdentificationInputField; // only in astoria
    communication2?: CustomerIdentificationInputField; // only in astoria
    department: CustomerIdentificationInputField;
    room: CustomerIdentificationInputField;
    materialNr: CustomerIdentificationInputField;
    serialNr: CustomerIdentificationInputField;
    orderNr: CustomerIdentificationInputField;
    mDate?: CustomerIdentificationInputField; // only in astoria
    systemId: CustomerIdentificationInputField;
    systemName?: CustomerIdentificationInputField; // only in cosima
    functionalLocation?: CustomerIdentificationInputField; // only in cosima
}>;

export const initialAstoriaCustomerIdentification: CustomerIdentification = {
    customer1: { ...initialCustomerIdentificationInputFieldState },
    customer2: { ...initialCustomerIdentificationInputFieldState },
    address1: { ...initialCustomerIdentificationInputFieldState },
    address2: { ...initialCustomerIdentificationInputFieldState },
    communication1: { ...initialCustomerIdentificationInputFieldState },
    communication2: { ...initialCustomerIdentificationInputFieldState },
    department: { ...initialCustomerIdentificationInputFieldState },
    materialNr: { ...initialCustomerIdentificationInputFieldState },
    orderNr: { ...initialCustomerIdentificationInputFieldState },
    mDate: { ...initialCustomerIdentificationInputFieldState },
    room: { ...initialCustomerIdentificationInputFieldState },
    serialNr: { ...initialCustomerIdentificationInputFieldState },
    systemId: { ...initialCustomerIdentificationInputFieldState },
};
export const initialCosimaCustomerIdentification: CustomerIdentification = {
    customer1: { ...initialCustomerIdentificationInputFieldState },
    customer2: { ...initialCustomerIdentificationInputFieldState },
    address1: { ...initialCustomerIdentificationInputFieldState },
    address2: { ...initialCustomerIdentificationInputFieldState },
    department: { ...initialCustomerIdentificationInputFieldState },
    materialNr: { ...initialCustomerIdentificationInputFieldState },
    orderNr: { ...initialCustomerIdentificationInputFieldState },
    room: { ...initialCustomerIdentificationInputFieldState },
    serialNr: { ...initialCustomerIdentificationInputFieldState },
    systemId: { ...initialCustomerIdentificationInputFieldState },
    systemName: { ...initialCustomerIdentificationInputFieldState },
    functionalLocation: { ...initialCustomerIdentificationInputFieldState },
};
